import { PageShell } from "@/components/layout/PageShell";
import { PageHeader } from "@/components/ui/page-header";
import { Seo } from "@/components/seo/Seo";
import { SITE_URL } from "@/lib/newsSeo";
import { T } from "@/i18n/T";

const EditorialStandards = () => (
  <PageShell>
    <Seo
      title="Editorial standards | Byteline"
      description="How Byteline sources, verifies, credits and corrects its reporting, and how artificial intelligence is used in our newsroom."
      path="/editorial-standards"
      jsonLd={[
        {
          "@context": "https://schema.org",
          "@type": "WebPage",
          url: `${SITE_URL}/editorial-standards`,
          name: "Editorial standards",
        },
      ]}
    />
    <PageHeader
      eyebrow="Standards"
      title="Editorial standards"
      description="How we source, verify, credit and correct our reporting."
    />

    <div className="prose dark:prose-invert max-w-3xl">
      <h2><T k="auto.sourcing-and-credit-1c70" /></h2>
      <p>
        Much of our coverage begins with reporting from other publications. When a story
        originates elsewhere, the original publisher is named on the page and linked, and
        the summary or rewrite is clearly marked as produced by Byteline.
      </p>

      <h2><T k="auto.use-of-artificial-intelligence-0101" /></h2>
      <p>
        We use AI to summarise, translate, clean up formatting and draft explanatory
        material. AI output is derived from the sourced material only. It does not invent
        figures, quotes or events. Anything labelled as written by Byteline AI is generated
        that way, and the source is always linked.
      </p>

      <h2><T k="auto.verification-0312" /></h2>
      <p>
        Market numbers come from exchange and market-data providers and are timestamped on
        the page. Where a claim cannot be traced back to a named source, we do not publish it.
      </p>

      <h2><T k="auto.corrections-ccc7" /></h2>
      <p>
        When a story is corrected, the page is updated in place and the last-updated date
        changes. [Placeholder: replace with your real corrections contact address and the
        time you aim to respond within.]
      </p>

      <h2><T k="auto.independence-1db5" /></h2>
      <p>
        [Placeholder: replace with your real statement on advertising, sponsorship,
        affiliate arrangements and ownership of assets we write about.]
      </p>
    </div>
  </PageShell>
);

export default EditorialStandards;
